/* ============================================================
   FILET STORE — Homepage JS
   Hero switcher · Filter bar · Sticky bar · Toast
   ============================================================ */

document.addEventListener('DOMContentLoaded', () => {

  /* ── HERO PRODUCT DATA ── */
  const heroProducts = {
    hub: {
      name: 'Hub USB-C 7-en-1 UGREEN', brand: 'UGREEN', price: '$49.990', retail: '$89.990',
      badge: 'Más vendido', img: 'https://m.media-amazon.com/images/I/61RIBrqiVJL._AC_SL1500_.jpg',
      eyebrow: 'Nuevo en stock · Santiago',
      sub: 'Conecta todo desde un solo punto. El hub que debería venir incluido con el MacBook.',
      url: '/collections/macbook'
    },
    teclado: {
      name: 'Teclado trackpad iPad ESR', brand: 'ESR', price: '$64.990', retail: '$119.990',
      badge: 'Nuevo', img: 'https://m.media-amazon.com/images/I/71fz7XKXTPL._AC_SL1500_.jpg',
      eyebrow: 'Alternativa al Magic Keyboard · −$55.000',
      sub: 'El teclado para iPad que no cuesta lo mismo que el iPad. Con trackpad, compatible iPad Pro M4.',
      url: '/collections/ipad'
    },
    cargador: {
      name: 'Cargador GaN 65W Baseus', brand: 'Baseus', price: '$29.990', retail: '$54.990',
      badge: '', img: 'https://m.media-amazon.com/images/I/61bhfxMhzML._AC_SL1500_.jpg',
      eyebrow: 'El cargador Apple cuesta $35.990 → el nuestro igual.',
      sub: 'GaN 65W, 3 puertos, compacto. iPhone, iPad y MacBook Air desde el mismo enchufe.',
      url: '/collections/carga'
    },
    audio: {
      name: 'Soundcore Liberty 5 ANC', brand: 'Soundcore · Anker', price: '$49.990', retail: '$89.990',
      badge: 'Nuevo', img: 'https://m.media-amazon.com/images/I/61ZkLq4KPEL._AC_SL1500_.jpg',
      eyebrow: 'Sin distribución oficial en Chile · Traído directo',
      sub: 'ANC activo, 40h de batería, Bluetooth 5.3. La alternativa real a los AirPods Pro a la mitad del precio.',
      url: '/collections/audio'
    }
  };
  let currentHero = 'hub';

  /* ── HERO PILL SWITCHER ── */
  const pills = document.querySelectorAll('.fs-hs-pill');
  pills.forEach(pill => {
    pill.addEventListener('click', () => {
      pills.forEach(p => p.classList.remove('active'));
      pill.classList.add('active');
      const key = pill.dataset.prod;
      currentHero = key;
      const p = heroProducts[key];
      const img = document.getElementById('fs-hero-img');
      if (img) {
        img.style.opacity = '0'; img.style.transform = 'scale(0.95)';
        setTimeout(() => { img.src = p.img; img.style.opacity = '1'; img.style.transform = 'scale(1)'; }, 200);
      }
      const el = id => document.getElementById(id);
      if (el('fs-hero-price'))  el('fs-hero-price').textContent  = p.price;
      if (el('fs-hero-retail')) el('fs-hero-retail').textContent = p.retail;
      if (el('fs-hero-eyebrow'))el('fs-hero-eyebrow').textContent= p.eyebrow;
      if (el('fs-hero-sub'))    el('fs-hero-sub').textContent    = p.sub;
      const badge = el('fs-hero-badge');
      if (badge) { badge.textContent = p.badge; badge.style.display = p.badge ? 'block' : 'none'; }
      if (el('fs-sticky-name'))  el('fs-sticky-name').textContent  = p.name;
      if (el('fs-sticky-price')) el('fs-sticky-price').textContent = p.price;
    });
  });

  /* ── HERO MODE SWITCH ── */
  document.querySelectorAll('.fs-mode-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      document.querySelectorAll('.fs-mode-btn').forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
      if (btn.dataset.mode === 'seminuevos') {
        document.getElementById('fs-seminuevos')?.scrollIntoView({ behavior: 'smooth' });
      }
    });
  });

  /* ── HERO CTA → colección ── */
  document.getElementById('fs-hero-cta')?.addEventListener('click', () => {
    window.location = heroProducts[currentHero].url;
  });
  document.getElementById('fs-hero-frame')?.addEventListener('click', () => {
    window.location = heroProducts[currentHero].url;
  });

  /* ── STICKY BUY BAR ── */
  const stickyBar = document.getElementById('fs-sticky-bar');
  const heroSection = document.getElementById('fs-hero');
  if (stickyBar && heroSection) {
    new IntersectionObserver(([e]) => stickyBar.classList.toggle('visible', !e.isIntersecting), { threshold: 0 }).observe(heroSection);
  }
  document.getElementById('fs-sticky-cta')?.addEventListener('click', () => {
    window.location = heroProducts[currentHero].url;
  });

  /* ── TOAST ── */
  window.fsToast = (msg, sub) => {
    const t = document.getElementById('fs-toast');
    if (!t) return;
    document.getElementById('fs-toast-msg').textContent = msg;
    if (sub) document.getElementById('fs-toast-sub').textContent = sub;
    t.classList.add('show');
    setTimeout(() => t.classList.remove('show'), 3000);
  };

  /* ── LED dot pulse aleatoria ── */
  document.querySelectorAll('.fs-led').forEach(dot => {
    dot.style.animationDelay = (Math.random() * 2) + 's';
  });

});
